// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"12":"ef4d2d16a713f5e8","176":"2482f93c23117d99","195":"65d6f7ae6e09ab02","205":"11022ff20bccf353","449":"89bf10e89a1a7aea","556":"c754b6ebda86a466"}[chunkId] + ".js";
};